/**
 * Query keys of the airline-reassignment reads (flight-delay U5). One module so the
 * hooks, the writes and the WS merge (`merge.ts`) can never disagree on a key.
 *
 * Both live under the case's `['cases', urn, 'rebooking']` subtree ON PURPOSE: the
 * BFF fans a `CaseChanged('rebooking')` out after every rebooking write of the case
 * (an adoption, a dismissal, a sync), and `lib/ws/apply-event.ts` invalidates that
 * prefix — so another console's dismissal refreshes an open list without a handler of
 * its own (an inactive one only flips stale).
 */

/** The case's airline reassignments (cases S7) — `IAirlineReassignment[]`. */
export function caseReassignmentsKey(caseUrn: string): readonly unknown[] {
  return ['cases', caseUrn, 'rebooking', 'airline-reassignments'] as const;
}

/** The case's open external decisions (`PENDING` + `CONFLICT`, B4) — `IExternalPendingView`. */
export function caseExternalPendingKey(caseUrn: string): readonly unknown[] {
  return ['cases', caseUrn, 'rebooking', 'external', 'pending'] as const;
}
